module.exports = __webpack_public_path__ + "img/t_6.a091d093.png";